/**
 * Page de vérification 2FA - React Vite
 *
 * Utilise des selecteurs Zustand individuels (pas useAuth()) pour eviter
 * les re-renders en cascade qui causent le detachement DOM des inputs 2FA.
 */

import { useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useAuthStore } from '../store/authStore';
import { TwoFactorForm } from '../components/forms/TwoFactorForm';

export function TwoFactorPage() {
  const navigate = useNavigate();
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const requires2FA = useAuthStore((s) => s.requires2FA);
  const twoFactorSessionData = useAuthStore((s) => s.twoFactorSessionData);

  useEffect(() => {
    // Si pas besoin de 2FA, rediriger
    if (!requires2FA) {
      navigate(isAuthenticated ? '/dashboard' : '/auth/login');
    }
  }, [isAuthenticated, requires2FA, navigate]);

  const handleSuccess = useCallback(() => {
    navigate('/dashboard');
  }, [navigate]);

  const handleError = useCallback((error: string) => {
    toast.error(error || 'Erreur de vérification 2FA');
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-raised py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-content">
            Vérification en deux étapes
          </h2>
          <p className="mt-2 text-center text-sm text-content-muted">
            Entrez le code de vérification
          </p>
        </div>
        <div className="bg-surface rounded-lg shadow-lg p-8">
          <TwoFactorForm
            userId={twoFactorSessionData?.idUtilisateur}
            method={twoFactorSessionData?.methode2FA}
            onSuccess={handleSuccess}
            onError={handleError}
          />
        </div>
      </div>
    </div>
  );
}

export default TwoFactorPage;
